import { DateTime } from 'luxon';

// Fallback gap between start and end when there's no existing duration to carry
// forward (e.g. the end field is empty or invalid). Deliberately distinct from
// the 2-hour default OperatorBookingCalendar.js uses when opening a brand new
// (empty) modal — that's the "starting point for a fresh block" default, this
// is the "we lost track of the gap, pick something sane" fallback.
export const NO_PRIOR_GAP_FALLBACK_MINUTES = 60;

// Parse a datetime-local ("yyyy-MM-ddTHH:mm") value for duration arithmetic.
// Pinned to UTC (rather than the browser's local zone) purely so plus/diff
// math is never perturbed by a DST transition in whatever zone the operator's
// browser happens to be set to — these strings are naive field-local wall-clock
// values, not real UTC instants.
const parseForDurationMath = (dt) => DateTime.fromISO(dt, { zone: 'utc' });

// Given the current Block Time form and a new start value, returns the form
// with startDateTime updated and endDateTime shifted to preserve whatever
// start-to-end gap was already set (so a custom 2 or 3 hour block stays that
// length), falling back to NO_PRIOR_GAP_FALLBACK_MINUTES when there was no
// valid existing gap.
export const applyStartChange = (f, newStart) => {
  const prevStart = parseForDurationMath(f.startDateTime);
  const prevEnd = parseForDurationMath(f.endDateTime);
  const durationMinutes = prevStart.isValid && prevEnd.isValid && prevEnd > prevStart
    ? prevEnd.diff(prevStart, 'minutes').minutes
    : NO_PRIOR_GAP_FALLBACK_MINUTES;

  const newStartDt = parseForDurationMath(newStart);
  const endDateTime = newStartDt.isValid
    ? newStartDt.plus({ minutes: durationMinutes }).toFormat("yyyy-MM-dd'T'HH:mm")
    : f.endDateTime;

  return { ...f, startDateTime: newStart, endDateTime };
};
